import {Pipe, PipeTransform} from '@angular/core';

/**
 * Conta o número de caracteres de uma string, excluindo espaços em branco
 * nas extremidades.
 *
 * Retorna `0` para strings nulas, indefinidas ou vazias.
 *
 * @example
 * {{ 'Lorem ipsum' | charCount }}
 * // 11
 *
 * @example
 * {{ '' | charCount }}
 * // 0
 */
@Pipe({name: 'charCount', standalone: true})
export class CharCountPipe implements PipeTransform {
    transform(value: string | null | undefined): number {
        if (!value) return 0;
        return value.length;
    }
}

